import liveMatrixStaticData from "../../data/livematrixData";
import underlyingChartStaticData from "../../data/underlyingchartData";
import calculatorStaticData from "../../data/calculatorData";
import {
  comparisonStaticData,
  underlyingStaticData,
} from "../../data/comparisonData";
import documentStaticData from "../../data/documentData";
import searchStaticData from "../../data/searchData";
import selectorStaticData from "../../data/selectorData";
import termStaticData from "../../data/termData";
import dwtoolStaticData from "../../data/dwtoolData";
import quickheadlineStaticData from "../../data/dwnewsData";
import seminarStaticData from "../../data/dweduData";
import dwturnoverStaticData from "../../data/dwturnoverData";
import rankingStaticData from "../../data/rankingData";
import turnoverdistStaticData from "../../data/turnoverdistData";
import dailyhighStaticData from "../../data/dailyhighData";
import highlightStaticData from "../../data/highlightData";
import photogalleryStaticData, { albumID } from "../../data/photogalleryData";
import overnighthighStaticData from "../../data/overnightData";
import seminarSectionStaticData from "../../data/seminarData";
import liveindexfutureStaticData from "../../data/liveindexfutureData";

class MQSGUtil {
  static indicators = [
    { value: "HIGHRESP", label: "Responsive", classname: "icon-responsive" },
    { value: "HOTLIST", label: "Hot warrants", classname: "icon-hotdw" },
    { value: "APPCHEXPRY", label: "Near Expiry", classname: "icon-expiry" },
    {
      value: "HIGHLQDY",
      label: "Highest liquidity",
      classname: "icon-liquidity",
    },
  ];

  static stripscript(s) {
    const pattern = new RegExp(
      /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g,
    );
    let rs = "";
    for (let i = 0; i < s.length; i++) {
      rs = rs + s.substr(i, 1).replace(pattern, "");
    }
    return rs;
  }
  static underlyingtickerdisplaynameMap = {
    N225: "Nikkei225",
    A17U: "AREIT",
    AWX: "AEM",
    "BABA-SW": "ALIBABA",
    "BILIBILI-SW": "BILIBILI",
    "BIDU-SW": "BAIDU",
    BN4: "KEPCORP",
    BVA: "TOPGLOVE",
    C31: "CAPLAND",
    C09: "CITYDEV",
    C52: "COMFORT",
    C6L: "SIA",
    D05: "DBS",
    F34: "WILMAR",
    G13: "GENTING",
    S08: "SINGPOST",
    BS6: "YANGZIJIANG",
    AIY: "IFAST",
    "JD-SW": "JD.com",
    N2IU: "MAPLECOMTRUST",
    "NTES-S": "NETEASE",
    O39: "OCBC",
    S51: "SEMBMAR",
    S68: "SGX",
    TENCENT: "TENCENT",
    U11: "UOB",
    U14: "UOL",
    V03: "VENTURE",
    "XIAOMI-W": "XIAOMI",
    Z74: "SINGTEL",
    "Top Glove": "TOP GLOVE",
    "GEELY AUTO": "GEELY",
    "MEITUAN-W": "MEITUAN",
    "SUNNY OPTICAL": "SUNNY",
    "BYD COMPANY": "BYD",
    "0208300": "HSTECH",
    "HANG SENG TECH": "HSTECH",
    "HANG SENG TECH INDEX": "HSTECH",
    S58: "SATS",
    T39: "SPH",
    GANFENGLITHIUM: "GANFENG",
    "9CI": "CAPITALANDINV",
    U96: "SembCorp Industries",
    NDX: "NASDAQ-100",
    DJI: "DOW JONES",
    M44U: "MapleTreeLogistics",
    "KUAISHOU-W": "KUAISHOU",
    "5E2": "Seatrium",
    S63: "ST Engineering",
  };

  static getUpDownClass(nc) {
    if (nc !== undefined && nc !== null && nc !== "") {
      const ncstring = nc.toString().trim();
      // Remove commas for proper number parsing
      const ncval = Number(ncstring.replace(/,/g, ""));

      if (!isNaN(ncval)) {
        // Check if 0
        if (ncval === 0) {
          return "";
        }
        // If -nnn ?
        else if (ncstring.length > 1 && ncstring.startsWith("-")) {
          return "val down";
        }
        // If +nnn ?
        else if (
          (ncstring.length > 1 && ncstring.startsWith("+")) ||
          ncval > 0
        ) {
          return "val up";
        }
      }
    }

    // Any other case, return ""
    return "";
  }

  static isPositive(value, isEqualtoZero = false) {
    let valueUse = value;
    if (typeof value === "string") {
      valueUse = valueUse.replace(/,/g, "");
      valueUse = valueUse.replace(/%/g, "");
    }
    const valueNumber = Number(valueUse);
    if (!isNaN(valueNumber)) {
      if (isEqualtoZero && valueNumber >= 0) {
        return true;
      } else if (valueNumber > 0) {
        return true;
      }
    }
    return false;
  }

  static signedString(
    value,
    posSign = "+",
    negSign = "-",
    isEqualtoZero = false,
  ) {
    if (MQSGUtil.isPositive(value, isEqualtoZero)) {
      return posSign + value;
    }
    return negSign + value;
  }

  static getData(source, fieldName, noData = "") {
    if (source !== undefined && source !== null && fieldName in source) {
      return source[fieldName];
    }
    return noData;
  }

  /**
   * 格式化数字显示值 - 用于在显示时统一处理数字格式
   * 当数据为空、null、undefined 或空字符串时，返回 "-"
   * 支持小数位和千位分隔符格式化
   * @param {*} value - 需要格式化的值
   * @param {number} [dp=3] - 小数点位数
   * @param {string} [defaultValue="-"] - 默认值
   * @param {boolean} [addComma=true] - 是否添加千位分隔符
   * @param {boolean} [forcePad=false] - 是否强制补齐小数位数（true 时等同于 toFixed 行为，会补零）
   * @returns {string} 格式化后的字符串
   */
  static formatNumberDisplay(value, dp = 3, defaultValue = "-", addComma = true, forcePad = false) {
    // 先检查是否为空
    if (value === null || value === undefined || value === "" || value === "N/A" || value === "n/a" || value === "NA" || value === "-" || value === "NaN") {
      return defaultValue;
    }
    if (typeof value === 'number' && isNaN(value)) {
      return defaultValue;
    }
    // 如果是字符串且包含逗号，先去除逗号（处理 "1,234.56" 这种情况）
    let stringValue = value;
    if (typeof value === 'string' && value.includes(',')) {
      stringValue = value.replace(/,/g, '');
    }
    
    // 检测原始数据是否带有正号或负号
    let hasPlusSign = false;
    let hasMinusSign = false;
    if (typeof stringValue === 'string') {
      if (stringValue.startsWith('+')) {
        hasPlusSign = true;
      } else if (stringValue.startsWith('-')) {
        hasMinusSign = true;
      }
    }
    
    // 转换为数字
    const numValue = Number(stringValue);
    
    // 如果不是数字，直接原样返回
    if (isNaN(numValue)) {
      return value;
    }
    
    // 保留小数位
    let formattedValue;
    if (dp !== null) {
      if (forcePad) {
        // 强制补齐到指定小数位数（等同于 toFixed 的行为）
        formattedValue = numValue.toFixed(dp);
      } else {
        // 获取数字的小数部分
        const parts = stringValue.toString().split('.');
        const decimalLength = parts.length > 1 ? parts[1].length : 0;

        // 如果小数位没有超过设定的小数位，保留原来的小数位
        // 如果小数位超过设定的小数位，最多保留设定的小数位数
        const targetDp = Math.min(decimalLength, dp);
        formattedValue = targetDp > 0 ? numValue.toFixed(targetDp) : numValue.toString();
      }
    } else {
      formattedValue = numValue.toString();
    }
    
    // 添加千位分隔符
    if (addComma) {
      const parts = formattedValue.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      formattedValue = parts.join('.');
    }
    
    // 如果原始数据带有正号或负号，补回符号
    if (!formattedValue.startsWith('+') && !formattedValue.startsWith('-')) {
      if (hasPlusSign) {
        formattedValue = `+${formattedValue}`;
      } else if (hasMinusSign) {
        formattedValue = `-${formattedValue}`;
      }
    }
    
    return formattedValue;
  }

  static getFormatPrice(source, fieldName, noData = "", dp = null) {
    // return is a string with comma
    const value = MQSGUtil.getNumber(source, fieldName, null, dp);
    if (value !== null) {
      return Intl.NumberFormat().format(value);
    }
    return noData;
  }

  static getNumber(
    source,
    fieldName,
    noData = "",
    dp = null,
    dividedBy = 1,
    formatAsPrice = false,
  ) {
    const value = MQSGUtil.getData(source, fieldName, null);
    if (value !== null) {
      let valueUse = value;
      if (typeof value === "string") {
        valueUse = valueUse.replace(/,/g, "");
        valueUse = valueUse.replace(/%/g, "");
      }
      valueUse = Number(valueUse) / dividedBy;
      if (!isNaN(valueUse)) {
        if (dp !== null) {
          valueUse = Number(valueUse.toFixed(dp));
        }
        if (formatAsPrice) {
          return Intl.NumberFormat().format(valueUse);
        }
        return valueUse;
      }
    }
    return noData;
  }

  static getDecimalPlace(number) {
    const numberString = number.toString();
    const decimalIndex = numberString.indexOf(".");
    if (decimalIndex > -1) {
      return Number(numberString.length - (decimalIndex + 1));
    }
    return 0;
  }

  static getFormatKValue(source, fieldName, noData = "", formatAsPrice = true) {
    let retvalue = noData;
    const value = MQSGUtil.getNumber(source, fieldName, null);
    if (value !== null) {
      if (value > 1000) {
        retvalue = (value / 1000).toFixed(0);
        if (formatAsPrice) {
          retvalue = new Intl.NumberFormat().format(retvalue);
        }
        retvalue = retvalue + "K";
      }
    }
    return retvalue;
  }

  static getIndicatorClassName(source) {
    let classnames = [];
    MQSGUtil.indicators.forEach((indicator) => {
      const value = MQSGUtil.getData(source, indicator.value, null);
      if (value !== null && value) {
        classnames.push(indicator.classname);
      }
    });
    return classnames;
  }

  static getUnderlyingTickerValue(ric) {
    let UnderlyingtickerdisplaynameMap = JSON.parse(
      window.localStorage.getItem("UnderlyingtickerdisplaynameMap"),
    );
    let value = UnderlyingtickerdisplaynameMap.filter((v) => {
      return v.underlying_ric === ric;
    });
    if (value.length > 0) {
      return value[0];
    } else {
      return null;
    }
  }
  static getUnderlyingTickerDisplayName(
    ric,
    underlyingticker,
    isReturnNull = false,
  ) {
    let UnderlyingtickerdisplaynameMap = JSON.parse(
      window.localStorage.getItem("UnderlyingtickerdisplaynameMap"),
    );
    let value = UnderlyingtickerdisplaynameMap.filter((v) => {
      return v.underlying_ric === ric;
    });
    if (isReturnNull) {
      return null;
    }
    if (value.length > 0) {
      return value[0].underlying_ticker;
    } else {
      return underlyingticker;
    }
  }
  static getScreenerJSONServlet = async () => {
    const url = MQSGUtil.getAPIBasePath() + "/ScreenerJSONServlet/ric";
    let ScreenerJSONServlet = await fetch(url)
      .then((res) => res.json())
      .then((result) => {
        return result;
      });
    window.localStorage.setItem(
      "UnderlyingtickerdisplaynameMap",
      JSON.stringify(ScreenerJSONServlet),
    );
  };
  static getLastSelection(page) {
    const selection = localStorage.getItem("lastview");
    if (selection !== undefined) {
      //  修改
      if (page !== "lastview") {
        if (selection !== null) {
          let lastViewSplit = selection.split(",");
          return lastViewSplit[0];
        }
      }
      return selection;
      // 修改
    }
    return null;
  }

  static updateLastSelection(page, selection) {
    localStorage.setItem(page, selection);
  }

  static updateLastView(newRic) {
    // string: ric1,ric2,..,ric5
    // save max 5 rics
    const MAX = 5;
    let lastView = MQSGUtil.getLastSelection("lastview");
    if (lastView !== null && lastView.length > 0) {
      let lastViewSplit = lastView.split(",");
      const index = lastViewSplit.indexOf(newRic);
      if (index === -1) {
        if (lastViewSplit.length === MAX) {
          // replace index = 0 with new ric
          lastViewSplit.splice(lastViewSplit.length - 1, 1);
          // lastViewSplit[0] = newRic;
          lastViewSplit.unshift(newRic);
        } else {
          // put the new ric in index = 0
          lastViewSplit.splice(0, 0, newRic);
        }
      } else {
        // move the ric to index = 0
        lastViewSplit.splice(index, 1); // remove duplicated
        // lastViewSplit.splice(0, 0, newRic);
        lastViewSplit.unshift(newRic);
      }
      lastView = lastViewSplit.join(",");
    } else {
      lastView = newRic;
    }
    MQSGUtil.updateLastSelection("lastview", lastView);
    return lastView;
  }

  static isValidDateString(datetimeString) {
    if (isNaN(Date.parse(datetimeString))) {
      return false;
    }
    return true;
  }

  static parseDateString(datetimeString) {
    const ms = Date.parse(datetimeString);
    if (isNaN(ms)) {
      return null;
    }
    return new Date(ms);
  }

  static getMonthString(index, isShortForm = true) {
    const months = {
      0: "January",
      1: "February",
      2: "March",
      3: "April",
      4: "May",
      5: "June",
      6: "July",
      7: "August",
      8: "September",
      9: "October",
      10: "November",
      11: "December",
    };
    if (index in months) {
      if (isShortForm) {
        return months[index].substring(0, 3);
      }
      return months[index];
    }
    return "";
  }

  static getDateString(dateObj) {
    // output YYYY-MM-DD
    if (dateObj instanceof Date) {
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const monthString = month.toString().padStart(2, "0");
      const day = dateObj.getDate();
      const dayString = day.toString().padStart(2, "0");
      const dateString = year + "-" + monthString + "-" + dayString;
      return dateString;
    }
    return "";
  }

  static getNewsDateString(dateString) {
    const ms = MQSGUtil.parseDateString(dateString);
    if (ms !== null) {
      const dateObj = new Date(ms);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth();
      const monthString = MQSGUtil.getMonthString(month, false);
      const day = dateObj.getDate();
      const dayString = day.toString().padStart(2, "0");
      const dateString = dayString + " " + monthString + " " + year;
      return dateString;
    }
    return "";
  }

  static isUsingStaticData(component = null) {
    const exception = [];
    if (component !== null && exception.indexOf(component) > -1) {
      return true;
    }
    return false;
  }

  static getStaticData(component) {
    let staticData = null;
    switch (component) {
      case "LiveMatrix":
        staticData = liveMatrixStaticData;
        break;
      case "UnderlyingChart":
        staticData = underlyingChartStaticData;
        break;
      case "WarrantCalculator":
        staticData = calculatorStaticData;
        break;
      case "WarrantComparison":
        staticData = { comparisonStaticData, underlyingStaticData };
        break;
      case "WarrantDocument":
        staticData = documentStaticData;
        break;
      case "WarrantSearch":
        staticData = searchStaticData;
        break;
      case "WarrantSelector":
        staticData = selectorStaticData;
        break;
      case "Warrantterms":
        staticData = termStaticData;
        break;
      case "WarrantTools":
        staticData = dwtoolStaticData;
        break;
      case "QuickHeadline":
        staticData = quickheadlineStaticData;
        break;
      case "Seminar":
        staticData = seminarStaticData;
        break;
      case "DWTurnover":
        staticData = dwturnoverStaticData;
        break;
      case "TopGainer":
      case "TopTraded":
        staticData = rankingStaticData;
        break;
      case "TurnoverDist":
        staticData = turnoverdistStaticData;
        break;
      case "DailyHighlights":
        staticData = dailyhighStaticData;
        break;
      case "HighLight":
        staticData = highlightStaticData;
        break;
      case "IndividualGallery":
        staticData = { photogalleryStaticData, albumID };
        break;
      case "OvernightMarkets":
        staticData = overnighthighStaticData;
        break;
      case "Gallery":
        staticData = photogalleryStaticData;
        break;
      case "SeminarSection":
        staticData = seminarSectionStaticData;
        break;
      case "LiveIndexFuture":
        staticData = liveindexfutureStaticData;
        break;
      default:
    }
    return staticData;
  }
  static getAPIImgPath() {
    return process.env.REACT_APP_MARKET_API + "/video/";
  }
  static getShortsVideoAPIImgPath() {
    return process.env.REACT_APP_MARKET_API + "/ShortsVideo/";
  }
  static getShortsVideoBannerAPIImgPath() {
    return process.env.REACT_APP_MARKET_API + "/shortsvideobanner/";
  }
  static getShortsPlaylistVideoAPIImgPath() {
    return process.env.REACT_APP_MARKET_API + "/shortsplaylist/";
  }
  static getAPIBasePath() {
    return process.env.REACT_APP_API_URL;
  }
  static filterDataSymbolsJSON(sourceData) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    const result = JSON.parse(JSON.stringify(sourceData || {}));

    if (!Array.isArray(result.symbols) || result.symbols.length === 0) {
      return result;
    }

    result.symbols.forEach((item) => {
      if (
        typeof item !== "object" ||
        item === null ||
        typeof item.ric !== "string"
      ) {
        return;
      }

      let needModify = false;
      const ric = item.ric;

      for (const str of arry) {
        if (str === ric) {
          needModify = true;
          break;
        }
      }

      if (
        !needModify &&
        arry.includes("HK") &&
        ric.toLowerCase().endsWith(".hk")
      ) {
        needModify = true;
      }
      if (
        !needModify &&
        arry.includes(".O") &&
        ric.toLowerCase().endsWith(".o")
      ) {
        needModify = true;
      }

      if (needModify) {
        item.TRDPRC_1 = "0";
      }
    });

    return result;
  }

  static filterDataWarrantComparison(sourceData, ric) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    const result = JSON.parse(JSON.stringify(sourceData || {}));
    if (
      ric === undefined ||
      ric === null ||
      (typeof ric === "string" && ric.trim() === "")
    ) {
      return result;
    }

    let needModify = false;
    const trimmedRic = ric.trim();

    for (const item of arry) {
      if (item.trim() === trimmedRic) {
        needModify = true;
        break;
      }
    }

    if (!needModify && arry.includes("HK")) {
      if (trimmedRic.toLowerCase().endsWith(".hk")) {
        needModify = true;
      }
    }
    if (!needModify && arry.includes(".O")) {
      if (trimmedRic.toLowerCase().endsWith(".o")) {
        needModify = true;
      }
    }

    if (needModify) {
      if (Array.isArray(result.comparison) && result.comparison.length > 1) {
        for (let i = 1; i < result.comparison.length; i++) {
          const currentItem = result.comparison[i];
          if (typeof currentItem === "object" && currentItem !== null) {
            currentItem.underlying_price = "-";
          }
        }
      }
    }

    return result;
  }
  static filterDataWarrantSelector(result) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];

    if (
      result.ric === undefined ||
      result.ric === null ||
      (typeof result.ric === "string" && result.ric.trim() === "")
    ) {
      return result;
    }
    let needModify = false;

    // 条件1：遍历arry匹配对象的ric字段
    for (const item of arry) {
      if (item === result.ric) {
        needModify = true;
        break;
      }
    }

    // 条件2：如果arry包含HK且ric含有.hk后缀
    if (!needModify && arry.includes("HK")) {
      if (result.ric.toLowerCase().endsWith(".hk")) {
        needModify = true;
      }
    }
    if (!needModify && arry.includes(".O")) {
      if (result.ric.toLowerCase().endsWith(".o")) {
        needModify = true;
      }
    }

    if (needModify) {
      if (result.symbol && typeof result.symbol === "object") {
        result.symbol.TRDPRC_1 = "0";
      }
      result.lastPriceModel = "-";
    }
    return result;
  }
  static filterDataUnderlyingChartData(sourceData, ric) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    const result = JSON.parse(JSON.stringify(sourceData || {}));

    let needModifyBID = false;

    if (typeof ric === "string" && ric.trim()) {
      for (const item of arry) {
        if (item.trim() === ric.trim()) {
          needModifyBID = true;
          break;
        }
      }
    }
    if (!needModifyBID && arry.includes("HK")) {
      if (
        typeof ric === "string" &&
        ric.trim() &&
        ric.trim().toLowerCase().endsWith(".hk")
      ) {
        needModifyBID = true;
      }
    }
    if (!needModifyBID && arry.includes(".O")) {
      if (
        typeof ric === "string" &&
        ric.trim() &&
        ric.trim().toLowerCase().endsWith(".o")
      ) {
        needModifyBID = true;
      }
    }
    if (needModifyBID) {
      const emptyData = {
        ...sourceData,
        data: [],
      };
      return emptyData;
    }

    return result;
  }

  static filterDataUnderlyingCharts(sourceData, ric) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    const result = JSON.parse(JSON.stringify(sourceData || {}));

    if (!Array.isArray(result.comparison)) {
      result.comparison = [];
      return result;
    }

    let needModifyBID = false;

    if (typeof ric === "string" && ric.trim()) {
      for (const item of arry) {
        if (item.trim() === ric.trim()) {
          needModifyBID = true;
          break;
        }
      }
    }

    if (!needModifyBID && arry.includes("HK")) {
      if (
        typeof ric === "string" &&
        ric.trim() &&
        ric.trim().toLowerCase().endsWith(".hk")
      ) {
        needModifyBID = true;
      }
    }
    if (!needModifyBID && arry.includes(".O")) {
      if (
        typeof ric === "string" &&
        ric.trim() &&
        ric.trim().toLowerCase().endsWith(".o")
      ) {
        needModifyBID = true;
      }
    }

    if (needModifyBID) {
      result.comparison.forEach((item) => {
        item.BID = "-";
      });
    }

    return result;
  }
  static filterDataLiveMatrixJSON(sourceData) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    let result = JSON.parse(JSON.stringify(sourceData || {}));

    if (!result.ric_data) {
      return result;
    }

    let { ric_data } = result;
    let needModify = false;

    for (const item of arry) {
      if (
        (typeof ric_data.ric === "string" && ric_data.ric === item) ||
        ric_data.underlying_ric === item
      ) {
        needModify = true;
        break;
      }
    }

    if (!needModify && arry.includes("HK")) {
      if (
        typeof ric_data.underlying_ric === "string" &&
        ric_data.underlying_ric.toLowerCase().endsWith(".hk")
      ) {
        needModify = true;
      }
    }
    if (!needModify && arry.includes(".O")) {
      if (
        typeof ric_data.underlying_ric === "string" &&
        ric_data.underlying_ric.toLowerCase().endsWith(".o")
      ) {
        needModify = true;
      }
    }
    if (needModify) {
      ric_data.showUnderlying_price = "-";
      ric_data.showUnderlying_bid = "-";
    } else {
      ric_data.showUnderlying_price = ric_data.underlying_price;
      ric_data.showUnderlying_bid = ric_data.underlying_bid;
    }
    return result;
  }
  static filterDataTopovers(sourceData) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    const result = JSON.parse(JSON.stringify(sourceData || {}));

    if (!result.topmover) {
      return result;
    }

    const processArray = (array) => {
      if (Array.isArray(array)) {
        array.forEach((item) => {
          if (typeof item.underlying_ric === "string") {
            if (arry.includes(item.underlying_ric)) {
              item.TRDPRC_1 = "-";
            }
            if (
              arry.includes("HK") &&
              item.underlying_ric.toLowerCase().includes(".hk")
            ) {
              item.TRDPRC_1 = "-";
            }
            if (
              arry.includes(".O") &&
              item.underlying_ric.toLowerCase().includes(".o")
            ) {
              item.TRDPRC_1 = "-";
            }
          }
        });
      }
    };

    processArray(result.topmover.SG_stocks);
    processArray(result.topmover.Indices);
    processArray(result.topmover.HK_stocks);

    return result;
  }

  static filterDataSelectorAlert(result, ric) {
    const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
    let needModify = false;
    for (const item of arry) {
      if (typeof ric === "string" && ric === item) {
        needModify = true;
        break;
      }
    }

    if (!needModify && arry.includes("HK")) {
      if (typeof ric === "string" && ric.toLowerCase().endsWith(".hk")) {
        needModify = true;
      }
    }
    if (!needModify && arry.includes(".O")) {
      if (typeof ric === "string" && ric.toLowerCase().endsWith(".o")) {
        needModify = true;
      }
    }

    if (needModify) {
      result.data = [];
    }
    return result;
  }

  /**
   * Get currency symbol based on symbol data
   * @param {Object} symbol - The symbol object containing name and ric
   * @returns {string} - Currency symbol (HK$, S$, or empty string)
   */
  static currency(symbol) {
    const symbolSname = symbol.name;
    if (
      symbolSname === "BABA" ||
      symbolSname === "JD" ||
      symbolSname === "NETEASE" ||
      symbolSname === "TENCENT" ||
      symbolSname === "XIAOMI" ||
      symbolSname === "BYD" ||
      (symbol.ric && symbol.ric.endsWith(".HK"))
    ) {
      return "HK$";
    } else if (
      symbolSname === "HSI" ||
      symbolSname === "N225" ||
      symbolSname === "S&P500" ||
      symbolSname === "STI" ||
      symbolSname === "HANG SENG TECH INDEX" ||
      symbolSname === "SiMSCI" ||
      symbolSname === "SEA" ||
      symbolSname === "NDX" ||
      symbolSname === "DJI"
    ) {
      return "";
    }
    return "S$";
  }
  static wrrantCurrency(symbol) {
    const symbolSname = symbol.underlying_ticker;
    if (
      symbolSname === "BABA" ||
      symbolSname === "JD" ||
      symbolSname === "NETEASE" ||
      symbolSname === "TENCENT" ||
      symbolSname === "XIAOMI" ||
      symbolSname === "BYD" ||
      (symbol.underlying_ric && symbol.underlying_ric.endsWith(".HK"))
    ) {
      return "HK$";
    } else if (
      symbolSname === "HSI" ||
      symbolSname === "N225" ||
      symbolSname === "S&P500" ||
      symbolSname === "STI" ||
      symbolSname === "HANG SENG TECH INDEX" ||
      symbolSname === "SiMSCI" ||
      symbolSname === "SEA" ||
      symbolSname === "NDX" ||
      symbolSname === "HSTECH" ||
      symbolSname === "DJI"
    ) {
      return "";
    } else if (symbolSname == "NIO") {
      return "US$";
    }
    return "S$";
  }

  /**
   * Filter option for react-select component
   * @param {Array} symbols - Array of symbol objects
   * @param {Object} candidate - The candidate option to filter
   * @param {string} input - The search input string
   * @returns {boolean} - Whether the candidate matches the input
   */
  static filterOption(symbols, candidate, input) {
    const { createFilter } = require("react-select");

    if (symbols !== null && symbols.length > 0) {
      const data = symbols;
      const value = MQSGUtil.stripscript(input).toUpperCase();
      const labelValue = MQSGUtil.stripscript(candidate.label).toUpperCase();

      if (
        "HSTECH".indexOf(value) != -1 &&
        labelValue.indexOf("HANGSENGTECHINDEX") != -1
      ) {
        return true;
      }

      for (let x = 0; x < data.length; x++) {
        const ricValue = data[x].ric;
        const nameValue = data[x].name;

        if (ricValue === candidate.data.ric) {
          const UnderlyingTickerValue =
            MQSGUtil.getUnderlyingTickerValue(ricValue);

          if (UnderlyingTickerValue !== null) {
            const labci_underlying_ticker = (
              UnderlyingTickerValue.labci_underlying_ticker ?? ""
            ).toUpperCase();
            const underlying_name = (
              UnderlyingTickerValue.underlying_name ?? ""
            ).toUpperCase();
            const underlying_ric = (
              UnderlyingTickerValue.underlying_ric ?? ""
            ).toUpperCase();
            const underlying_ticker = (
              UnderlyingTickerValue.underlying_ticker ?? ""
            ).toUpperCase();

            if (
              labci_underlying_ticker.indexOf(value) != -1 ||
              underlying_name.indexOf(value) != -1 ||
              underlying_ric.indexOf(value) != -1 ||
              underlying_ticker.indexOf(value) != -1
            ) {
              return true;
            }
          }

          const nameValues = (nameValue ?? "").toUpperCase();
          if (value.indexOf(nameValues) !== -1) {
            return true;
          }
        }
      }

      return createFilter()(candidate, input);
    } else {
      const value = MQSGUtil.stripscript(input).toUpperCase();
      const labelValue = MQSGUtil.stripscript(candidate.label).toUpperCase();

      if (
        "HSTECH".indexOf(value) != -1 &&
        labelValue.indexOf("HANGSENGTECHINDEX") != -1
      ) {
        return true;
      }
      if (labelValue.indexOf(value) != -1) {
        return true;
      }

      return createFilter()(candidate, input);
    }
  }

  /**
   * Get underlying options for react-select component
   * @param {Array} symbols - Array of symbol objects from underlying data
   * @returns {Array} - Formatted options array
   */
  static getUnderlyingOption(symbols) {
    if (!symbols || !Array.isArray(symbols)) {
      return null;
    }

    let index = [];
    let list = [];

    const options = symbols.map((element) => {
      const diplayname = MQSGUtil.getUnderlyingTickerDisplayName(
        element.ric,
        element.symbol,
        false,
      );
      const symbol = diplayname;
      const label =
        (symbol == "BABA-SW" ? "ALIBABA" : symbol) +
        " " +
        MQSGUtil.currency(element) +
        element["TRDPRC_1"] +
        " (" +
        (element["PCTCHNG"] < 0
          ? element["PCTCHNG"]
          : "+" + element["PCTCHNG"]) +
        "%)";
      const value = element.ric;

      return {
        ...element,
        symbol,
        label,
        value,
      };
    });

    options.forEach((element) => {
      if (
        element.symbol == "HSI" ||
        element.symbol == "N225" ||
        element.symbol == "S&P500" ||
        element.symbol == "STI" ||
        element.symbol == "HSTECH" ||
        element.symbol === "SiMSCI"
      ) {
        index.push(element);
      } else {
        list.push(element);
      }
    });

    list.sort((a, b) => a.symbol.localeCompare(b.symbol));

    return [...index, ...list].sort((a, b) => {
      return a.label.localeCompare(b.label);
    });
  }
}
export default MQSGUtil;
